import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { startAutoRetranslate } from './utils/googleTranslate';
import Home from './pages/Home/Home';
import AadharReminder from './components/AadharReminder/AadharReminder';
import GoogleTranslateWidget from './components/GoogleTranslate/GoogleTranslateWidget';
import NotFound from './pages/NotFound/NotFound';
import OfflineScreen from './components/Offline/OfflineScreen';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import RouteSeo from './components/Seo/RouteSeo';
import SupportChatLauncher from './components/Support/SupportChatLauncher';
import './App.css';
import './styles/WeddingPages.css';
import './styles/PublicPageTheme.css';
import './styles/LanguageScale.css';
import './styles/PageSecondaryAccents.css';

// every page except the home page loads when it is opened, so the first visit downloads much less JavaScript
const Browse = lazy(() => import('./pages/Browse/Browse'));
const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const ServiceProvider = lazy(() => import('./pages/ServiceProvider/ServiceProvider'));
const Horoscope = lazy(() => import('./pages/Horoscope/Horoscope'));
const SeoLanding = lazy(() => import('./pages/SeoLanding/SeoLanding'));
const Plans = lazy(() => import('./pages/Plans/Plans'));
const Services = lazy(() => import('./pages/Services/Services'));
const ServiceDetail = lazy(() => import('./pages/Services/ServiceDetail'));
const AllServiceCards = lazy(() => import('./pages/Services/AllServiceCards'));
const SuccessStories = lazy(() => import('./pages/SuccessStories/SuccessStories'));
const AdminPanel = lazy(() => import('./pages/Admin/AdminPanel'));
const Contact = lazy(() => import('./pages/Contact/Contact'));
const FAQ = lazy(() => import('./pages/FAQ/FAQ'));
const Blog = lazy(() => import('./pages/Blog/Blog'));
const BlogPost = lazy(() => import('./pages/Blog/BlogPost'));
const AboutUs = lazy(() => import('./pages/AboutUs/AboutUs'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./pages/TermsConditions/TermsConditions'));
const ProfileDetail = lazy(() => import('./pages/Profile/ProfileDetail'));
const Messages = lazy(() => import('./pages/Messages/Messages'));
const Notifications = lazy(() => import('./pages/Notifications/Notifications'));
const LanguageSelect = lazy(() => import('./pages/LanguageSelect/LanguageSelect'));
const Register = lazy(() => import('./pages/Register/Register'));

function App() {
  React.useEffect(() => { startAutoRetranslate(); }, []);
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <RouteSeo />
        <OfflineScreen />
        <SupportChatLauncher />
        <Toaster position="top-center" />
        <GoogleTranslateWidget />
        <AadharReminder />
        <Suspense fallback={<div style={{ minHeight: '70vh' }} />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />  {/* ✅ ADD THIS */}
          <Route path="/browse" element={<Browse />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/service-provider" element={<ServiceProvider />} />
          <Route path="/horoscope" element={<Horoscope />} />
          {/* search landing pages (content/seoPages.js) */}
          <Route path="/matrimony/:slug" element={<SeoLanding />} />
          <Route path="/wedding-services/:slug" element={<SeoLanding />} />
          <Route path="/ta/:slug" element={<SeoLanding />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/services" element={<Services />} />
          <Route path="/all-services" element={<AllServiceCards />} />
          <Route path="/services/:id" element={<ServiceDetail />} />
          <Route path="/success-stories" element={<SuccessStories />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/profile/:id" element={<ProfileDetail />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/language" element={<LanguageSelect />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
      </Router>
    </AuthProvider>
  );
}

export default App;
